export const CREATE_USER= 'user@create-user';
export const DELETE_USER= 'user@delete-user';
export const GET_USER= 'user@get-user';
export const UPDATE_USER= 'user@update-user';
